import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isEmpty',
	pure: true
})
export class IsEmptyPipe implements PipeTransform {
	transform(value: any): boolean {
		if (value == null || value === '') return true; // null, undefined and empty strings
		if (Array.isArray(value) || typeof value === 'string') return value.length === 0;
		if (typeof value !== 'object') return true;

		for (var prop in value) {
		    if (value.hasOwnProperty(prop)) {
		        return false;
			}	
		}
		return true;		
	}
}
